import React from "react";
import { StyleSheet, View, StyleProp, ViewStyle } from "react-native";

export type VerificationCheckIconProps = {
  style?: StyleProp<ViewStyle>;
  color: string;
};

export const VerificationCheckIcon: React.FC<VerificationCheckIconProps> = ({
  color,
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      <svg width="9" height="9" viewBox="0 0 13 13">
        <g transform="translate(-1818 -10178)">
          <circle
            cx="6.5"
            cy="6.5"
            r="6.5"
            transform="translate(1818 10178)"
            fill={color}
          />
          <path
            d="M1814.054,10184.139l2.116,2.133,3.78-4.089"
            transform="translate(7.446 0.318)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
